import React from "react";
import * as Icons from "lucide-react";
import { cn } from "@/lib/utils";

export default function MetricCard({ label, value, delta, deltaLabel, icon = "TrendingUp", accent = "#8B5CF6", testId }) {
  const Icon = Icons[icon] || Icons.TrendingUp;
  const positive = delta === undefined || delta >= 0;
  return (
    <div
      data-testid={testId}
      className="glass rounded-xl p-5 relative overflow-hidden group hover:bg-white/[0.05] transition-colors"
    >
      <div
        className="absolute -right-8 -top-8 w-32 h-32 rounded-full opacity-30 blur-2xl transition-opacity group-hover:opacity-50"
        style={{ background: accent }}
        aria-hidden="true"
      />
      <div className="flex items-start justify-between relative">
        <div>
          <div className="text-[11px] uppercase tracking-[0.14em] text-white/45 font-medium">{label}</div>
          <div className="mt-2 text-3xl font-semibold tracking-tight text-white">{value}</div>
          {delta !== undefined && (
            <div className={cn(
              "mt-2 inline-flex items-center gap-1 text-xs",
              positive ? "text-[#6EE7B7]" : "text-[#FCA5A5]"
            )}>
              {positive ? <Icons.ArrowUpRight className="w-3.5 h-3.5" /> : <Icons.ArrowDownRight className="w-3.5 h-3.5" />}
              <span>{Math.abs(delta)}%</span>
              {deltaLabel && <span className="text-white/40 ml-1">{deltaLabel}</span>}
            </div>
          )}
        </div>
        <div
          className="w-10 h-10 rounded-lg flex items-center justify-center"
          style={{ background: `${accent}22`, border: `1px solid ${accent}44` }}
        >
          <Icon className="w-5 h-5" style={{ color: accent }} />
        </div>
      </div>
    </div>
  );
}
